import React from 'react';
import { landingConfig } from '../config/landingConfig';

export default function AboutSupportSection() {
  return (
    <section id="about" aria-labelledby="about-statement-sync" className="border-t border-slate-200 bg-white py-16">
      <div className="mx-auto grid max-w-7xl gap-8 px-4 sm:px-6 lg:grid-cols-[1.35fr_0.65fr] lg:items-start lg:px-8">
        <div className="max-w-3xl">
          <span className="text-xs font-medium uppercase tracking-[0.12em] text-blue-600">About & support</span>
          <h2 id="about-statement-sync" className="mt-4 text-slate-950">Who is behind StatementSync?</h2>
          <p className="mt-5 max-w-[72ch] text-base leading-7 text-slate-600">
            StatementSync is developed and supported by BPA Solutions in Australia. It is built to help small businesses,
            bookkeepers, accountants, property investors, admin teams and individuals turn readable bank statement PDFs
            into reviewable Excel and CSV transaction data with less manual retyping.
          </p>
          <p className="mt-4 max-w-[72ch] text-base leading-7 text-slate-600">
            StatementSync is a workflow tool for preparing cleaner transaction data; it does not replace accounting or
            bookkeeping software, and users can review and edit extracted rows before export.
          </p>
        </div>

        <div id="contact" className="rounded-2xl border border-slate-200 bg-slate-50 p-6 shadow-sm">
          <h3 className="text-slate-950">How can I contact BPA Solutions?</h3>
          <p className="mt-3 text-sm leading-6 text-slate-600">
            For StatementSync product or licence support, contact BPA Solutions directly.
          </p>
          <address className="mt-5 not-italic text-sm leading-7">
            <div className="font-semibold text-slate-950">BPA Solutions</div>
            <a href={`mailto:${landingConfig.supportEmail}`} className="block font-medium text-blue-600 hover:text-blue-700">
              {landingConfig.supportEmail}
            </a>
            <a href={`tel:${landingConfig.contactPhone.replace(/\s/g, '')}`} className="block font-medium text-blue-600 hover:text-blue-700">
              {landingConfig.contactPhone}
            </a>
            <a href={landingConfig.websiteUrl} target="_blank" rel="noopener noreferrer" className="block font-medium text-blue-600 hover:text-blue-700">
              www.bpasolutions.au
            </a>
          </address>
        </div>
      </div>

      <div className="mx-auto mt-12 max-w-7xl border-t border-slate-200 px-4 pt-8 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-5 lg:flex-row lg:items-start lg:justify-between">
          <div className="max-w-3xl">
            <p className="text-sm font-semibold text-slate-700">Privacy & data-storage note</p>
            <p className="mt-2 text-sm leading-6 text-slate-500">
              StatementSync does not use a backend database to store your uploaded bank statements or extracted transaction data. Purchase, licensing and entitlement information may be handled separately by the relevant payment and licensing services.
            </p>
          </div>
          <nav aria-label="Legal" className="flex flex-wrap gap-x-5 gap-y-2 text-sm font-medium">
            <a href={landingConfig.legalLinks.terms} target="_blank" rel="noopener noreferrer" className="text-slate-600 underline-offset-4 hover:text-blue-600 hover:underline">Service Terms</a>
            <a href={landingConfig.legalLinks.privacy} target="_blank" rel="noopener noreferrer" className="text-slate-600 underline-offset-4 hover:text-blue-600 hover:underline">Privacy Policy</a>
            <a href={landingConfig.legalLinks.refunds} target="_blank" rel="noopener noreferrer" className="text-slate-600 underline-offset-4 hover:text-blue-600 hover:underline">Refund Policy</a>
          </nav>
        </div>
        <p className="mt-6 text-xs leading-5 text-slate-400">Please review the applicable terms, privacy policy and refund policy before purchasing or using StatementSync.</p>
      </div>
    </section>
  );
}